import { ListScrollComponent } from './ListScrollComponent';

export default ListScrollComponent;
